export const isNullOrUndefined = (value: unknown) => {
  return value === null || value === undefined;
};
